var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 7.96875C26.25 11.3342 21.2132 14.0625 15 14.0625C8.7868 14.0625 3.75 11.3342 3.75 7.96875C3.75 4.60327 8.7868 1.875 15 1.875C21.2132 1.875 26.25 4.60327 26.25 7.96875Z",
    fill: "#32AE4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.9375C18.3565 15.9375 21.4881 15.2046 23.848 13.9264C24.7105 13.4592 25.531 12.8804 26.2184 12.1959C26.2393 12.3479 26.25 12.5014 26.25 12.6563C26.25 16.0217 21.2132 18.75 15 18.75C8.7868 18.75 3.75 16.0217 3.75 12.6563C3.75 12.5014 3.76066 12.3479 3.78162 12.1959C4.46903 12.8804 5.28953 13.4592 6.15202 13.9264C8.51186 15.2046 11.6435 15.9375 15 15.9375Z",
    fill: "#32AE4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.625C18.3565 20.625 21.4881 19.8921 23.848 18.6138C24.7105 18.1467 25.531 17.5679 26.2184 16.8834C26.2393 17.0354 26.25 17.1889 26.25 17.3437C26.25 20.7092 21.2132 23.4375 15 23.4375C8.7868 23.4375 3.75 20.7092 3.75 17.3437C3.75 17.1889 3.76066 17.0354 3.78162 16.8834C4.46903 17.5679 5.28953 18.1467 6.15202 18.6138C8.51186 19.8921 11.6435 20.625 15 20.625Z",
    fill: "#32AE4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.3125C18.3565 25.3125 21.4881 24.5796 23.848 23.3013C24.7105 22.8342 25.531 22.2554 26.2184 21.5709C26.2393 21.7229 26.25 21.8764 26.25 22.0312C26.25 25.3967 21.2132 28.125 15 28.125C8.7868 28.125 3.75 25.3967 3.75 22.0312C3.75 21.8764 3.76066 21.7229 3.78162 21.5709C4.46903 22.2554 5.28953 22.8342 6.15202 23.3013C8.51186 24.5796 11.6435 25.3125 15 25.3125Z",
    fill: "#32AE4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleStack);
export default __webpack_public_path__ + "static/media/circle-stack.bb442118878478853d17d6014d5c73eb.svg";
export { ForwardRef as ReactComponent };